<script>
  export default{
      getLocalImage(image){
          if(image.includes('/')){
              return image;
          }

          let localImage = 'img/icons/' + image;

          return localImage;
      },
      convertBase64StringToBlob(base64String, blobType)
      {
        const byteArray = Uint8Array.from(
            atob(base64String)
            .split('')
            .map(char => char.charCodeAt(0))
        );
        return new Blob([byteArray], { type: blobType});
      },
      convertStringToMD5(string)
      {
        var md5 = require('md5');
        return md5(string);
      },
      validateSameCharsInString(string)
      {
        var res = true;
        var fc = string[0];
        var i;

        for (i = 0; i < string.length; i++)
        {
          if (string[i] != fc)
          {
            res = false;
          }
        }

        return res;
      }
  }
</script>